import type { UIAdapterModule } from "../types";
import { parseGatewayGatewayStdoutLine } from "@ligament/adapter-gateway/ui";
import { buildGatewayGatewayConfig } from "@ligament/adapter-gateway/ui";
import { GatewayGatewayConfigFields } from "./config-fields";

export const gatewayGatewayUIAdapter: UIAdapterModule = {
  type: "gateway",
  label: "Gateway Gateway",
  parseStdoutLine: parseGatewayGatewayStdoutLine,
  ConfigFields: GatewayGatewayConfigFields,
  buildAdapterConfig: buildGatewayGatewayConfig,
};
